import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { Alert } from '../../services/Alert';

import { useAuth } from '../../auth/useAuth';
import logo_down from '../../assets/img/download.svg';

export const AcusePage = () => {

    const auth = useAuth();
    
    //Parametros por url
    const { folio } = useParams();
    
    //Parametros por query
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const folioQ = query.get('folio') || '';

    const [state, setstate] = useState({
        acuse:[],
        totales:{
            total: 0,
            importe:0
        },
        folio: folio || folioQ,
        mensaje: '',
        cargado: false,
        config: JSON.parse(localStorage.getItem('config'))
    })

    const loadAcuseList = () => {
        
        const getData = async() => {
            const config = JSON.parse(localStorage.getItem('config'));
            const BaseUrl = config.baseUrl || 'http://localhost/wservices/';
            const AppId = config.appId ||'';

            if(AppId===''){
                //Volvemos a llamar la funcion hasta acabar
                //reloadAcuse();
                return;
            }
            
            try{
                //console.log(state);
                const data = {
                    apikey: AppId || '',
                    action: 'GetAcuse',
                    provider: 'proveedor',
                    data: {
                        usuario: auth.user.usuario,
                        tabla: auth.user.tabla,
                        clave: auth.user.clave,
                        folio: state.folio!==''?state.folio:'%'
                    }
                }
                
                await axios.post(BaseUrl, data)
                .then(response => {
                    return response.data
                })
                .then(datos => {
                    
                    if((datos.type || '') === ''){
                        Alert('Advertencia: No hubo respuesta del servidor','warning',{});
                        return;
                    }
                    
                    //Ya tenemos una respuesta valida, ahora la procesamos
                    if(datos.type === 'error'){
                        Alert('Advertencia: '+ datos.code + ' - ' + datos.message,'warning',{});
                        return;
                    }
                    
                    const resultado = datos.data || {};
                    
                    let listacuse = resultado.acuse || [];
                    let itotales = {
                        total:0,
                        importe:0
                    }

                    listacuse.forEach(element => {
                        itotales.total++;
                        itotales.importe+=parseFloat(element.importe || 0)
                    });
                    
                    setstate({
                        ...state, 
                        acuse: listacuse, 
                        totales: itotales, 
                        mensaje: resultado.mensaje || '', 
                        cargado: true, 
                        config: config 
                    });
                    
                }).catch(error => {
                    Alert('Error: '+error.message,'error',{});
                });
            }catch(error){
                Alert('Error: '+error.message,'error',{});
            }
        }

        getData();
    }

    const toCurrency = (val, dec) => {
        const valor = parseFloat(val);
        return '$' + (valor.toFixed(dec)).toString();
    }

    useEffect(() => {
        if(!state.cargado){
            loadAcuseList();
        }
    }, [])

    return (
        <div className="container mt-5 mb-5">
            <div className='row'>
                <h1 className='m8-h2 animated fadeIn'>Acuses</h1>
                <h6 className='m8-h4 animated fadeIn'>{ auth.user.descripcion }</h6>
            </div>
            <div className="row">
            { state.mensaje !== '' ? (
                <div className="mb-3 mt-3">
                    { state.mensaje }
                </div>
            ) : '' }
            </div>
            <div className="row">
                <div className="mb-3 mt-3">
                    <table className="table table-bordered table-sm m8-table">
                        <thead>
                            <tr>
                                <th className='text-center'>#</th>
                                <th className='text-center'>Id</th>
                                <th className='text-center'>Documento</th>
                                <th className='text-center'>RFC</th>
                                <th className='text-center'>Empresa</th>
                                <th className='text-center'>Fecha</th>
                                <th className='text-center'>Alta</th>
                                <th className='text-center'>Importe</th>
                                <th className='text-center'>#</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                state.acuse.map(row => (
                                <tr className="" key={row.folio + row.id}>
                                    <td>{ row.folio }</td>
                                    <td>{ row.id }</td>
                                    <td>{ row.documento }</td>
                                    <td>{ row.rfc_emisor }</td>
                                    <td>{ row.empresa }</td>
                                    <td>{ row.fecha }</td>
                                    <td>{ row.alta }</td>
                                    <td align="right">{ toCurrency(row.importe,2) }</td>
                                    <td>
                                        <a className="link" href={ state.config.baseUrl + 'adjunto/?dbid=' + state.config.appId + '&tb=PROVEEDOR_FACTURA&dc=' + row.folio + row.id + '&id=0001' } target="_blank" rel="noreferrer">
                                            <img src={ logo_down } className="card-img-top m8-itext" style={{ width: '20px'}} alt="Descargar" />
                                        </a>
                                    </td>
                                </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="7">Total: { state.totales.total }</td>
                                <td align="right">{ toCurrency(state.totales.importe,2) }</td>
                                <td>#</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}
